export enum CpdsAspectRatioType {
  CPDS_16x9 = "CPDS_16x9",
  CPDS_5x4 = "CPDS_5x4",
  CPDS_4x3 = "CPDS_4x3",
  CPDS_3x2 = "CPDS_3x2",
  CPDS_1x1 = "CPDS_1x1",
  CPDS_2x3 = "CPDS_2x3",
  CPDS_3x4 = "CPDS_3x4",
  CPDS_4x5 = "CPDS_4x5",
  CPDS_9x16 = "CPDS_9x16",
}

export enum CpdsObjectFitType {
  CPDS_COVER = "CPDS_COVER",
  CPDS_CONTAIN = "CPDS_CONTAIN",
  CPDS_FILL = "CPDS_FILL",
  CPDS_NONE = "CPDS_NONE",
  CPDS_SCALE_DOWN = "CPDS_SCALE_DOWN",
  CPDS_UNSET = "CPDS_UNSET",
}

export const extractAspectRatio = (aspectRatio: string): string => {
  const match = aspectRatio.match(/\[(\d+)x(\d+)\]/);
  if (match) {
    const [, number1, number2] = match;
    return `${number1} / ${number2}`;
  }
  return '';
}

export enum CpdsBorderRadiusSizesType {
  CPDS_0px = "CPDS_0px",
  CPDS_4px = "CPDS_4px",
  CPDS_8px = "CPDS_8px",
  CPDS_12px = "CPDS_12px",
  CPDS_16px = "CPDS_16px",
  CPDS_20px = "CPDS_20px",
  CPDS_ROUNDED = "CPDS_ROUNDED",
}

export const  extractBorderRadius = (borderRadius: string): string => {
  const match = borderRadius.match(/\[(.*)\]/);
  if (match) {
    return match[1];
  }
  return '';
}